
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 47 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","fill":"#4FA2B7"}}),_c('path',{attrs:{"d":"M13.657 13.001a.728.728 0 00-.657.725v2.901c0 .4.328.725.733.725h.978v4.352h-.978a.73.73 0 00-.733.725v2.901c0 .4.328.725.733.725h.978v4.352h-.978a.73.73 0 00-.733.725v2.901c0 .4.328.725.733.725h2.934a.73.73 0 00.733-.725v-.725h4.4v.725c0 .4.328.725.733.725h2.934a.73.73 0 00.733-.725v-.725h4.4v.725c0 .4.328.725.733.725h2.934a.73.73 0 00.733-.725v-2.901a.73.73 0 00-.733-.725h-.978v-4.352h.978A.73.73 0 0035 25.33v-2.9a.73.73 0 00-.733-.726h-.978v-4.352h.978a.73.73 0 00.733-.725v-2.9a.728.728 0 00-.657-.726.742.742 0 00-.076 0h-2.934a.73.73 0 00-.733.725v.725h-4.4v-.725a.73.73 0 00-.733-.725h-2.934a.742.742 0 00-.076 0 .728.728 0 00-.657.725v.725h-.978a.742.742 0 00-.692.396.72.72 0 00.038.725.737.737 0 00.654.33h.978v.725c0 .4.328.725.733.725h2.934a.73.73 0 00.733-.725v-.725h4.4v.725c0 .4.328.725.733.725h.49v4.352h-.49a.73.73 0 00-.733.725v2.901c0 .4.328.725.733.725h.49v4.352h-.49a.73.73 0 00-.733.725v.725h-4.4v-.725a.73.73 0 00-.733-.725h-2.934a.73.73 0 00-.733.725v.725h-4.4v-.725a.73.73 0 00-.733-.725h-.49v-4.352h.49a.73.73 0 00.733-.725v-2.9a.73.73 0 00-.733-.726h-.49v-4.352h.49a.73.73 0 00.733-.725v-.725h.978a.735.735 0 00.644-.36.718.718 0 000-.73.735.735 0 00-.644-.36H17.4v-.726a.73.73 0 00-.733-.725h-2.934a.742.742 0 00-.076 0zm.81 1.45h1.466v1.451h-1.466v-1.45zm8.8 0h1.466v1.451h-1.466v-1.45zm8.8 0h1.466v1.451h-1.466v-1.45zm-17.6 8.703h1.466v1.45h-1.466v-1.45zm17.6 0h1.466v1.45h-1.466v-1.45zm-17.6 8.703h1.466v1.45h-1.466v-1.45zm8.8 0h1.466v1.45h-1.466v-1.45zm8.8 0h1.466v1.45h-1.466v-1.45z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/otherAreaFill.svg